// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { jsonMember, jsonObject } from "typedjson";
import ChannelID from "./types/channelID";
import { MessageType, MessageTypeName } from "./messageTypes";

@jsonObject
export default class CloseChannel extends PerunMessage {
  @jsonMember(ChannelID) id: ChannelID;
  @jsonMember(Boolean) forceClose: boolean;
  @jsonMember(String) withdrawalAddress?: string;

  constructor(id: ChannelID, forceClose = false, withdrawalAddress?: string) {
    super();
    this.id = id;
    this.forceClose = forceClose;
    this.withdrawalAddress = withdrawalAddress;
  }

  messageType(): MessageType {
    return CloseChannel;
  }

  messageTypeName(): MessageTypeName {
    return "CloseChannel";
  }
}
